<main>
  <!-- List Details -->
  <div *ngIf="!viewMode">
    <div class="teacher-head flex-wrap gap-2">
      <div
        class="d-flex align-items-center gap-3"
        style="cursor: pointer"
        (click)="goBack()"
      >
        <img src="assets/images/Buttons/arrow-left.svg" class="back-icon" />
        <div class="header-text teacher-text">Teachers</div>
      </div>
      <div class="d-flex gap-3 align-items-center flex-wrap gap-2">
        <!-- <div> -->
        <div class="search-container">
          <div class="search-icon">
            <img
              src="assets/icons/side-bar/search-normal.svg"
              alt="search"
              style="width: 18px; height: 18px"
            />
          </div>
          <input
            type="text"
            placeholder="Search here..."
            class="search-input"
            [(ngModel)]="search"
            (input)="updateSearch(search)"
            (keyup.enter)="applyFilter()"
            autocomplete="off"
          />
        </div>
        <!-- </div> -->
        <div *ngIf="userRoles.bulkUpload">
          <app-button
            context="upload"
            label="Bulk upload"
            (clicked)="openAddBulkDialog()"
          ></app-button>
        </div>
        <div *ngIf="userRoles.addNew">
          <app-button
            label="Add teacher"
            (clicked)="openAddTeacherDialog()"
          ></app-button>
        </div>

    <app-export-dropdown
  label="Export"
  *ngIf="userRoles.export"
  [apiWise]="true"
  [exportApiUrl]="getExportApiUrl()"
  [tableName]="'Teachers'"
  [currentParams]="getCurrentExportParams()"
  [isSearch]="!!search"
  (export)="onExportComplete($event)"
>
</app-export-dropdown>
      </div>
      <!-- <app-export-dropdown label="Export" [exportUrl]="exportUrl" [processData]="transformApiData"
                [columns]="exportColumns" tableName="Teachers List" *ngIf="userRoles?.export">
            </app-export-dropdown> -->
    </div>

    <div>
      <div class="table-card">
        <app-table
          [columns]="columns"
          [data]="data"
          [loading]="dataLoading"
          [actionTemplate]="actionButtonsTemplate"
          (rowClick)="onView($event)"
          (statusClick)="onStatusUpdate($event)"
          tableName="Teaches list"
          [totalItems]="totalRecords"
          [currentPage]="currentPage"
          [pageSize]="pageSize"
          [sortColumn]="sortColumn"
          [sortDirection]="sortDirection"
          (pageChange)="onPageChange($event)"
          (sortClick)="onSort($event)"
          [serverSidePagination]="true"
        >
        </app-table>
      </div>
    </div>
  </div>

  <!-- View Details -->
  <div *ngIf="viewMode" class="d-flex flex-column gap-4">
    <div
      class="d-flex align-items-center gap-3"
      style="cursor: pointer"
      (click)="goBack()"
    >
      <img src="assets/images/Buttons/arrow-left.svg" class="back-icon" />
      <div class="header-text teacher-text">Back to teachers</div>
    </div>

    <div *ngIf="selectedSchool" class="teacher-card">
      <div class="d-flex gap-4 flex-wrap">

        <!-- Initials Avatar -->
        <div class="teacher-profile teacher-initials">
          {{ getTeacherInitials() }}
        </div>

        <!-- Info Section -->
        <div class="d-flex flex-column gap-2 flex-grow-1">
          <div class="d-flex justify-content-between align-items-start w-100">
            <div class="d-flex flex-column gap-2">

              <!-- Name + Status Badge -->
              <div class="d-flex gap-2 align-items-center flex-wrap">
                <img src="assets/images/male_student.svg" class="teacher-icon" />
                <div class="text-head">{{ getTeacherFullName() }}</div>
                <div
                  [ngStyle]="{
                    'background-color': getTeacherStatusColor(),
                    'color': '#000',
                    'padding': '3px 12px',
                    'border-radius': '20px',
                    'font-size': '13px',
                    'font-weight': '600',
                    'white-space': 'nowrap'
                  }"
                >
                  {{ getTeacherStatusLabel() }}
                </div>
              </div>

              <!-- School Name -->
              <div class="d-flex gap-2 align-items-center" *ngIf="selectedSchool.schoolName">
                <img src="assets/images/student_school.svg" class="teacher-icon" />
                <div class="teacher-school-link">{{ selectedSchool.schoolName }}</div>
              </div>

            </div>

            <!-- Edit Button -->
            <div
              class="edit-button"
              (click)="onEdit(selectedSchool)"
              *ngIf="userViewRoles.edit"
            >
              <img
                alt="edit"
                class="edit-img"
                src="assets/images/Buttons/edit-button.svg"
              />
            </div>
          </div>

          <!-- Email + Phone -->
          <div class="details-section mt-2">
            <div class="d-grid gap-1">
              <div class="secondary-text">School email</div>
              <div class="main-text">{{ selectedSchool.email || "-" }}</div>
            </div>
            <div class="border-side"></div>
            <div class="d-grid gap-1">
              <div class="secondary-text">Phone number</div>
              <div class="main-text">{{ selectedSchool.mobileNumber || "-" }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="table-details">
      <div class="settings-bg">
        <div class="table-header">
          <img src="assets/icons/side-bar/students.svg" />
          Students
        </div>

        <div class="table-page">
          <div>
            <app-table
              [columns]="studentcolumns"
              [data]="studentData"
              [loading]="loading"
              [actionTemplate]="actionButtonsStudent"
            >
            </app-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>

<ng-template #actionButtons let-row>
  <div style="display: flex; gap: 0.8rem; justify-content: center">
    <img
      class="action-button"
      *ngIf="userRoles.listItem.view"
      (click)="onView(row)"
      src="assets/images/Buttons/view-button.svg"
      alt="View"
    />
    <img
      class="action-button"
      *ngIf="userRoles.listItem.edit"
      (click)="onEdit(row)"
      src="assets/images/Buttons/edit-button.svg"
      alt="Edit"
    />
    <img
      class="action-button"
      *ngIf="userRoles.listItem.delete"
      (click)="onDelete(row)"
      src="assets/images/Buttons/delete-button.svg"
      alt="Delete"
    />
  </div>
</ng-template>

<ng-template #actionButtonsStudent let-row>
  <div style="display: flex; gap: 0.8rem; justify-content: center">
    <img
      class="action-button"
      (click)="onStudentView(row)"
      src="assets/images/Buttons/view-button.svg"
      alt="View"
    />
  </div>
</ng-template>
